export const INVOICING_FREQUENCIES = {
  1: 'Weekly',
  2: 'Biweekly',
  3: 'Monthly',
  4: 'Bimonthly'
}

export const WEEKLY = 1

export const BIWEEKLY = 2

export const MONTHLY = 3

export const BIMONTHLY = 4
